/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import {
  CreateAttributeProps,
  CreateFeatureProps,
  CreateValueProps,
  DeleteAttributeProps,
  DeleteFeatureProps,
  DeleteValueProps,
  UpdateAttributeProps,
  UpdateFeatureProps,
  UpdateValueProps,
} from "./components";
const is = require("is_js");

const SERVICE_NAME = "InventoryTemplatePageService";
const log: any = LoggerModule.getInstance();

export class InventoryTemplatePageService {
  private static instance: InventoryTemplatePageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): InventoryTemplatePageService {
    if (!InventoryTemplatePageService.instance) {
      InventoryTemplatePageService.instance = new InventoryTemplatePageService(
        props,
      );
    }
    return InventoryTemplatePageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }
  public async getPageContent(args?: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getHeaderProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    compProps = await agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    // compProps = await agent.getFooterProps({});
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }

    const templateContent = await agent.getTemplateCostumeTypes(args);
    if (templateContent) {
      content = {
        ...content,
        ...templateContent,
      };
    }

    return content;
  }
  public async createFeature(args: CreateFeatureProps) {
    const agent = getAgent();
    return agent.createFeature(args);
  }

  public async updateFeature(args: UpdateFeatureProps) {
    const agent = getAgent();
    return agent.updateFeature(args);
  }

  public async deleteFeature(args: DeleteFeatureProps) {
    const agent = getAgent();
    return agent.deleteFeature(args);
  }

  public async createAttribute(args: CreateAttributeProps) {
    const agent = getAgent();
    return agent.createAttribute(args);
  }

  public async updateAttribute(args: UpdateAttributeProps) {
    const agent = getAgent();
    return agent.updateAttribute(args);
  }

  public async deleteAttribute(args: DeleteAttributeProps) {
    const agent = getAgent();
    return agent.deleteAttribute(args);
  }

  public async createValue(args: CreateValueProps) {
    const agent = getAgent();
    return agent.createValue(args);
  }

  public async updateValue(args: UpdateValueProps) {
    const agent = getAgent();
    return agent.updateValue(args);
  }

  public async deleteValue(args: DeleteValueProps) {
    const agent = getAgent();
    return agent.deleteValue(args);
  }

  public async getCostumeTypePreview(costumeTypeId: string) {
    const agent = getAgent();
    return agent.getCostumeTypePreview(costumeTypeId);
  }

  public async getTemplateCostumeTypes(args?: any) {
    const agent = getAgent();
    return agent.getTemplateCostumeTypes(args);
  }

  public async importCostumeType(args: {
    presentation: string;
    templateCostumeType: string;
  }) {
    const agent = getAgent();
    return agent.importCostumeType(args);
  }
}
